import AOS from 'aos';

(function($){
    let AOS = require("aos");

    /* ~~~~~~~~~~ Bootstrap Nav tabs on shown event ~~~~~~~~~~ */

        $('.nav-tabs a').on("shown.bs.tab", e => {
            AOS.refresh();
        });

    /*
    * On Dropdown change.
    * */



    $(window).on("resize", function() {

        /* ~~~~~~~~~~ Refresh ~~~~~~~~~~ */

        AOS.refreshHard();

    });

    $(document).on("lazyloaded", function(){

        /* ~~~~~~~~~~ Refresh ~~~~~~~~~~ */

        AOS.refreshHard();
    });

})(jQuery);
